import React, { Component } from 'react'
import { Container, Dimmer, Loader } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect, Route, Switch } from 'react-router-dom'
import { sellerContext } from '../../services/User';
import { setAuthState, setShowSidebar } from '../../store/actions/actions';
import buyerRoutes from '../../common/buyerRoutes';
import sellerDriverRoutes from '../../common/sellerDriverRoutes';
import topError from '../../assets/images/newui/top-error.svg'
import '../../assets/css/common.less'
import './MasterContainer.less'
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import SignInContainerNew from '../SignInContainer/SignInContainerNew';
import PrivacyPolicyContainer from '../DocumentsContainerNew/PrivacyPolicyContainer';
import TermsOfServiceContainer from '../DocumentsContainerNew/TermsOfUseContainer';
import PasswordResetRequestContainerNew from '../PasswordResetRequestContainer/PasswordResetRequestContainerNew';
import PasswordChangeContainerNew from '../PasswordChangeContainer/PasswordChangeContainerNew';
import FindUsContainer from '../FindUsContainer/FindUsContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { getProfile, showRequests, getTOSInfo } from '../../services/Seller';
import CompleteProfileContainerNew from '../CompleteProfileContainer/CompleteProfileContainerNew';
import { NavigationUrls } from '../../constants/NavigationUrls';
import { setSellerProfileCompleted, setActiveSubscriptionCount, setInActiveSubscriptionCount, setTOSSigned } from '../../store/actions/seller';
import { setTOSEnabled } from '../../store/actions/actions'
import { _ } from 'globalthis/implementation';
import SellerSignupContainer from '../SellerSignupContainer/SellerSignupContainer';
import AcceptedBidsContainer from '../AcceptedBidsContainer/AcceptedBidsContainer';
import ProfileContainer from '../ProfileContainer/ProfileContainer';
import RequestDetail from '../RequestDetailContainer/RequestDetailContainer';
import PlaceBidContainerNew from '../PlaceBidContainerNew/PlaceBidContainerNew';
import UserRestrictedRoute from '../../components/UserRestrictedRoute/UserRestrictedRoute';
import PasswordResetContainerNew from '../PasswordResetContainer/PasswordResetContainerNew';
import TopNavigationBar from '../../components/TopNavigationBar/TopNavigationBar';
import ActiveSubscriptionContainer from '../ActiveSubscriptionContainer/ActiveSubscriptionContainer';
import SubscriptionContainer from '../SubscriptionContainer/SubscriptionContainer';
import InActiveSubscriptionContainer from '../InActiveSubscriptionContainer/InActiveSubscriptionContainer';
import { getActiveSubscriptionsCount, getInActiveSubscriptions } from '../../services/subscription';
import NoSubscriptionContainer from '../NoSubscriptionContainer/NoSubscriptionContainer';
import CommissionPaymentsContainer from '../CommissionPaymentsContainer/CommissionPaymentsContainer';
import { getFailedCommissionPaymentsCount } from '../../services/payment';
import OpenRequestsContainer from '../OpenRequests/OpenRequestsContainer';
import InvoiceContainer from '../InvoiceContainer/InvoiceContainer';
import SellerServicesContainer from '../SellerServicesContainer/SellerServicesContainer';
import ServiceArea from '../ServiceArea/ServiceArea';
import TopPanel from '../../components/TopPanel/TopPanel';
import OpenRequestsByMarketContainer from '../OpenRequests/OpenRequestsByMarketContainer';
import RestrictedSBRDetails from '../RestrictredSBRDetails/RestrictedSBRDetails';
import TermsOfService from '../TermsOfServiceContainer/TermsOfService';
import { checkIsTOSEnabled } from '../../services/Common';
import SellerPaymentMethod from '../../containers/SellerPaymentMethod/SellerPaymentMethod';
import CreateCustomerRequestContainer from '../SellerCustomer/CreateCustomerRequestContainer/CreateCustomerRequestContainer';
import CustomerRequestFormContainer from '../SellerCustomer/CustomerRequestFormContainer/CustomerRequestFormContainer'
import CustomerRequestsContainer from '../SellerCustomer/CustomerRequestsContainer/CustomerRequestsContainer'
import CustomerRequestsInvoiceDetailContainer from '../SellerCustomer/CustomerRequestsInvoiceDetailContainer/CustomerRequestsInvoiceDetailContainer'
import InvoiceSettingsContainer from '../SellerCustomer/InvoiceSettingsContainer/InvoiceSettingsContainer';
import DriverInviteAcceptanceContainer from '../SellerDriver/DriverInviteAcceptanceContainer/DriverInviteAcceptanceContainer';
import Preferences from '../Preferences/Preferences';
import WorkingSchedules from '../WorkingSchedules/WorkingSchedules';
import SellerDriverContainer from '../SellerDriverListContainer/SellerDriverListContainer';
import InviteSellerDriverContainer from '../InviteSellerDriverContainer/InviteSellerDriverContainer';
import { NotificationContainer } from 'react-notifications';
import DispatchedRequestsContainer from '../SellerDriver/DispatchedRequestsContainer/DispatchedRequestsContainer'


const initialState = {
    lat: 0,
    lon: 0,
    locationSet: false,
    results: [],
    searchValue: '',
    isLoading: false,
    selectedServiceId: 0,
    selectedServiceName: '',
    serviceSEOName: '',
    showZipModalLoader: false,
    windowWidth: window.innerWidth,
    sidebarVisible: false,
    loadPage: false,
    showMenuBar: false,
    failedCommissionPaymentsCount: 0,
    sellerID: 0,
    sellerDriverID: 0, 
    showNavMenu: false,
    showRequests: false,
    activeSubscriptionsCountDataLoaded: false,
    inActiveSubscriptionsCountDataLoaded: false
};


class MasterContainer extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.hiwRef = React.createRef();
        this.pageTopRef = React.createRef();

    }

    async componentDidMount() {
        try {
            this.updateWindowDimensions();
            window.addEventListener('resize', this.updateWindowDimensions);

            const { loggedIn, currentUser, seller } = this.props;
            if (loggedIn) {
                this.setSubscriptionsCountToStore();
            }

            let tosCheckRes = await checkIsTOSEnabled();

            if (tosCheckRes.resStatus == 200) {
                this.props.setTOSEnabled(tosCheckRes.data.enabled)
            } else {
                this.props.setTOSEnabled(false);
            }

            if (!loggedIn || _.isEmpty(currentUser)) {

                //const response = await userContext();
                const response = await sellerContext();
                const isSeller = response && response.data && response.data.user && response.data.user.Seller ? true : false;
                const isSellerDriver = response && response.data && response.data.user && response.data.user.SellerDriver ? true : false;
                const sellerDriver = response && response.data && response.data.user && response.data.user.SellerDriver ? response.data.user.SellerDriver : null;
                if (isSeller) {
                    const showRequestsRes = await showRequests();
                    if (showRequestsRes.resStatus == 200) {
                        this.setState({ showRequests: showRequestsRes.data })
                    }
                }

                if (response && response.data) {

                    this.props.setAuthState(true, response.data.user, '');

                    if (isSeller) {
                        if (!this.props.seller.profileCompleted) {

                            const profileResponse = await getProfile();
                            const profile = profileResponse.data;

                            if ((_.isNull(profile.isProfileCompleted) || profile.isProfileCompleted === false)) {

                                if (!window.location.pathname.endsWith(NavigationUrls.COMPLETE_PROFILE_URL)) {
                                    this.props.history.push(`${NavigationUrls.COMPLETE_PROFILE_URL}`);
                                    this.setState({ showMenuBar: false })
                                    //return;
                                    //window.location = NavigationUrls.COMPLETE_PROFILE_URL;
                                }

                            }
                            else {

                                this.props.setSellerProfileCompleted(true);
                                //this.setState({ showMenuBar: true });

                                if (!this.props.seller.tosSigned) {
                                    await this.handleTOSNotSigned();
                                }

                            }

                        }
                        else {

                            if (!this.props.seller.tosSigned) {
                                await this.handleTOSNotSigned();
                            }

                        }
                    } else if (isSellerDriver) {
                        if (sellerDriver && !sellerDriver.isInviteAccepted) {
                            this.props.history.push(NavigationUrls.DRIVER_INVITE_ACCEPTANCE);
                        }
                        this.setState({ showMenuBar: true })
                    }
                }
            }

            if (this.props.currentUser) {
                this.setState({
                    sellerID: this.props.currentUser.Seller.sellerID,
                    sellerDriverID: this.props.currentUser.SellerDriver?.sellerDriverID || 0
                });
            }
        }
        catch (e) {
            //console.log( "error : ", e);
        }


        this.setState({ loadPage: true });
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });

    }

    async componentDidUpdate(prevProps) {
        if (this.props.loggedIn != prevProps.loggedIn && this.props.loggedIn) {
            if (this.props.isSeller) {
                const { data } = await getProfile();
                this.setState({ sellerID: data.sellerID });
            }
            if (this.props.isSellerDriver) {
                this.setState({ sellerDriverID: this.props.currentUser.SellerDriver?.sellerDriverID || 0, showMenuBar: true });
            }
        }

        if (this.props.isTOSEnabled) {
            if (prevProps.seller.tosSigned != this.props.seller.tosSigned && this.props.seller.tosSigned) {
                this.setState({ showMenuBar: true });
            }
        }
        if (this.props.isSeller && prevProps.seller.tosSigned != this.props.seller.tosSigned && this.props.seller.tosSigned && this.props.seller.profileCompleted == true) {
            await this.setSubscriptionsCountToStore();
            //const { data } = await getProfile();
            //this.setState({ sellerID: data.sellerID })
            const failedPayments = await getFailedCommissionPaymentsCount();
            this.setState({ failedCommissionPaymentsCount: failedPayments ? failedPayments.data : 0, showMenuBar: true })

            const showRequestsRes = await showRequests();
            if (showRequestsRes.resStatus == 200) {
                this.setState({ showRequests: showRequestsRes.data })
            }
        }
    }

    async shouldComponentUpdate(nextProps) {
        if (this.props.isSeller && this.props.location.pathname !== nextProps.location.pathname && this.props.loggedIn == true) {
            const failedPayments = await getFailedCommissionPaymentsCount();
            this.setState({ failedCommissionPaymentsCount: failedPayments ? failedPayments.data : 0 })
        }
    }

    setSubscriptionsCountToStore = () => {
        getActiveSubscriptionsCount().then(({ data }) => {
            this.props.setActiveSubscriptionCount(Number(data.count));
            this.setState({ activeSubscriptionsCountDataLoaded: true })
        });

        getInActiveSubscriptions().then(({ data: inActiveSubs }) => {
            this.props.setInActiveSubscriptionCount(inActiveSubs.length);
            this.setState({ inActiveSubscriptionsCountDataLoaded: true })
        });
    }

    handleTOSNotSigned = async () => {
        if (this.props.isTOSEnabled) {
            if (this.props.loggedIn) {

                const tosResponse = await getTOSInfo();
                if (!_.isNull(tosResponse) && !_.isEmpty(tosResponse.data)) {
                    const tos = tosResponse.data;
                    this.props.history.push(`/agreement/${tos.catSEOName}`);
                }
                else {
                    this.props.setTOSSigned(true);
                    this.setState({ showMenuBar: true })
                }
            }
        } else {
            this.props.setTOSSigned(true);
            this.setState({ showMenuBar: true });
        }

        // if (this.props.loggedIn) {
        //     const tosResponse = await getTOSInfo();
        //     if (!_.isNull(tosResponse) && !_.isEmpty(tosResponse.data)) {
        //         const tos = tosResponse.data;
        //         this.props.history.push(`/agreement/${tos.catSEOName}`);
        //     }
        //     else {
        //         this.props.setTOSSigned(true);
        //         this.setState({ showMenuBar: true })
        //     }
        // }

    }

    handleHamburgerIcon = () => {
        this.props.setShowSidebar(!this.props.showSidebar);
        setTimeout(() => {
            //this.props.setShowSidebar(false);
        }, 5000);

    }

    onBackToTopClick = () => {
        this.pageTopRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    toggleNavMenu = () => {
        this.setState({ showNavMenu: !this.state.showNavMenu })
    }
    closeNavMenu = () => {
        this.setState({ showNavMenu: false })
    }

    render() {

        const { activeMenuItem, currentUser, loggedIn, seller: { activeSubscriptionsCount, inActiveSubscriptionsCount, profileCompleted, tosSigned }, isSeller, isSellerDriver } = this.props;

        let routes = []

        if (isSeller) {
            // Managing seller routes
            routes = !profileCompleted ? buyerRoutes.filter(br => [NavigationUrls.COMPLETE_PROFILE_URL].includes(br.path))
                : (this.props.isTOSEnabled && !tosSigned) ? []
                    : activeSubscriptionsCount || this.state.sellerID == 1 ? buyerRoutes : inActiveSubscriptionsCount ?
                        buyerRoutes.filter(br => [NavigationUrls.IN_ACTIVE_SUBSCRIPTION, NavigationUrls.PROFILE_URL, NavigationUrls.PENDING_COMMISSION_PAYMENTS, NavigationUrls.INVOICES].includes(br.path)) :
                        buyerRoutes.filter(br => [NavigationUrls.PROFILE_URL, NavigationUrls.PENDING_COMMISSION_PAYMENTS, NavigationUrls.INVOICES].includes(br.path));
        } else if (isSellerDriver) {
            // Managing seller driver routes
            routes = sellerDriverRoutes
        }



        // Remove create customer request from menu if isSaasEnabled is false
        if (!this.props.currentUser?.Seller?.isSaasEnabled) {
            routes = routes.filter(br => br.path != NavigationUrls.CREATE_CUSTOMER_REQUEST)
        }

        return (this.state.loadPage &&
            <>
                <Container fluid>
                    <div id="page" >
                        {
                            this.state.showNavMenu &&
                            <>
                                {/* <TopNavigationBarNew  closeNavMenu={this.closeNavMenu}/> */}
                                <div onClick={() => this.toggleNavMenu()} className={"bg-blur"}>

                                </div>
                            </>
                        }
                        <TopPanel
                            pageTopRef={this.pageTopRef}
                            isCheckoutPage={this.props.location.pathname.split('/').slice(0, -1).join('/') == NavigationUrls.BUSINESS_CHECKOUT.split('/').slice(0, -1).join('/')}
                            //showActiveRequests={this.state.showRequests} 
                            showActiveRequests={false}
                            closeNavMenu={this.closeNavMenu}
                            showNavMenu={this.state.showNavMenu}
                            routes={routes}
                            showMenuBar={this.state.showMenuBar}
                            toggleNavMenu={this.toggleNavMenu}
                        />

                        {/* <div key="top-panel" className="master-top-panel" ref={this.pageTopRef}>
                        <div className="content-panel">
                            <div className="top-bar-new">
                                <Menu className="master-menu">
                                    <Menu.Item header className="header-logo">
                                        <a href="/"><img src={logo} className="logo" /></a>
                                    </Menu.Item>

                                    <Menu.Menu position='right' className="top-bar-links">

                                        {!this.props.loggedIn && this.state.windowWidth > 768 && this.props.location.pathname != "/business/signup" &&
                                            <React.Fragment>
                                                <Menu.Item as="a" className="joinaspro" href="/business/signup" name="joinaspro">Join As A Business</Menu.Item>
                                            </React.Fragment>
                                        }

                                        {!this.props.loggedIn && this.state.windowWidth > 768 &&

                                            <Menu.Item>
                                                <Button className="button-primary" href="/signin">Login</Button>
                                            </Menu.Item>


                                        }

                                        {!this.props.loggedIn && this.state.windowWidth <= 768 && (this.state.windowWidth < 768 || this.props.location.pathname != "/business/signup") &&
                                            <Menu.Item>
                                                <Dropdown className="responsive-menu" trigger={<img src={hamburger_icon} />}>

                                                    <Dropdown.Menu>


                                                {this.props.location.pathname != "/business/signup" && <Dropdown.Item key='menu_joinpro' text="Join As A Business" onClick={() => {
                                                    this.props.history.push({
                                                        pathname: '/business/signup',
                                                        state: { visitTime: moment().unix() }
                                                    });

                                                }} icon="user" />}

                                                        {this.state.windowWidth < 768 &&
                                                            <Dropdown.Item key='menu_login'>

                                                                <Button className="button-primary" href="/signin">Login</Button>
                                                            </Dropdown.Item>

                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Menu.Item>
                                        }




                                        {this.props.loggedIn &&
                                            <Menu.Item>
                                                <Dropdown className="loggedin-user" text={`${currentUser.firstName.charAt(0)}`} >

                                                    <Dropdown.Menu>
                                                        <div className="balloon">
                                                            <div>
                                                                <div>{`${currentUser.firstName.charAt(0)}`}</div>
                                                            </div>
                                                            <div>
                                                                {`${currentUser.firstName} ${currentUser.lastName}`}
                                                            </div>
                                                        </div>
                                                        {this.state.showMenuBar && <> {
                                                            routes.map(({ path, icon, name, showInSideBar }, key) => (
                                                                showInSideBar &&
                                                                <Dropdown.Item key={key} text={name} onClick={() => {
                                                                    this.props.history.push({
                                                                        pathname: path,
                                                                        state: { visitTime: moment().unix() }
                                                                    });

                                                                }} icon={icon} />


                                                            ))
                                                        }
                                                            <Dropdown.Item onClick={() => {
                                                                this.props.history.push({
                                                                    pathname: '/change-password',
                                                                    state: { visitTime: moment().unix() }
                                                                })
                                                            }} text="Change Password" icon="key" /> </>}
                                                        <Dropdown.Item text="Sign Out" icon="sign-out" onClick={logout} />



                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Menu.Item>
                                        }
                                    </Menu.Menu>



                                </Menu>

                            </div>
                        </div>
                    </div> */}



                        {inActiveSubscriptionsCount
                            && activeSubscriptionsCount
                            && this.props.location.pathname != NavigationUrls.ADD_SUBSCRIPTION
                            && this.props.location.pathname != '/inactive-subscription' ? <div className='top-bar-error'>
                            <img src={topError} />
                            <div className='top-bar-error-msg'>
                                You’ve {inActiveSubscriptionsCount} subscription(s) with failed payments. Please <a href='/inactive-subscription'>clear</a> them now so you can have access to all customers and features.
                            </div>
                        </div> : ''}

                        {this.state.failedCommissionPaymentsCount
                            && this.props.location.pathname != NavigationUrls.ADD_SUBSCRIPTION
                            && this.props.location.pathname.split('/').slice(0, -1).join('/') != NavigationUrls.ADD_SUBSCRIPTION_WITH_PLAN.split('/').slice(0, -1).join('/')
                            && this.props.location.pathname.split('/').slice(0, -1).join('/') != NavigationUrls.BUSINESS_CHECKOUT.split('/').slice(0, -1).join('/')
                            && this.props.location.pathname != NavigationUrls.PENDING_COMMISSION_PAYMENTS ? <div className='top-bar-error'>
                            <img src={topError} />
                            <div className='top-bar-error-msg'>
                                You’ve {this.state.failedCommissionPaymentsCount} failed commission payment(s). Please <a href={NavigationUrls.PENDING_COMMISSION_PAYMENTS}>clear</a> them now.
                            </div>
                        </div> : ''}

                        {
                            this.state.loadPage
                            && this.state.showMenuBar
                            && loggedIn
                            && !this.props.location.pathname.includes(NavigationUrls.ADD_SUBSCRIPTION)
                            && !this.props.location.pathname.endsWith('place-bid')
                            && this.props.location.pathname.split('/').slice(0, -1).join('/') != NavigationUrls.BUSINESS_CHECKOUT.split('/').slice(0, -1).join('/')
                            && (activeSubscriptionsCount != 0 || this.state.sellerID == 1)
                            && this.props.seller.profileCompleted
                            && (this.props.isTOSEnabled == true ? this.props.seller.tosSigned == true ? true : false : true)
                            && <TopNavigationBar /*showActiveRequests={this.state.showRequests}*/ showActiveRequests={false} />
                        }



                        {!loggedIn || this.state.sellerID ? <div className="master-content-pane">
                            {
                                // Seller is logged in and have any active Subscription

                                !loggedIn
                                    || activeSubscriptionsCount
                                    || this.state.sellerID == 1
                                    ?
                                    (<Switch>
                                        {
                                            //this.state.showRequests == true && this.props.seller.profileCompleted && this.props.seller.tosSigned && <PrivateRoute exact path="/" component={OpenRequestsContainer} /> 
                                        }
                                        {
                                            !loggedIn ? <UserRestrictedRoute exact path="/" component={SignInContainerNew} />
                                                :
                                                <UserRestrictedRoute path="/signin*" component={SignInContainerNew} />
                                        }

                                        <Route exact path="/privacy-policy/" component={PrivacyPolicyContainer} />
                                        <Route exact path="/terms-of-use" component={TermsOfServiceContainer} />
                                        <UserRestrictedRoute exact path="/reset-password-request" component={PasswordResetRequestContainerNew} />
                                        <UserRestrictedRoute exact path="/password-reset/:passwordResetHash" component={PasswordResetContainerNew} />
                                        <UserRestrictedRoute exact path="/business/signup" component={SellerSignupContainer} />
                                        <UserRestrictedRoute exact path={NavigationUrls.BUSINESS_CHECKOUT} component={SellerSignupContainer} alternate={SubscriptionContainer} />
                                        <UserRestrictedRoute exact path={NavigationUrls.REQUESTS_BY_MARKET} component={OpenRequestsByMarketContainer} />
                                        <PrivateRoute exact path="/change-password" component={PasswordChangeContainerNew} />
                                        <PrivateRoute exact path={`${NavigationUrls.COMPLETE_PROFILE_URL}`} component={CompleteProfileContainerNew} />

                                        {
                                            /*this.state.showRequests == false && */
                                            this.props.seller.profileCompleted
                                            && (this.props.isTOSEnabled == true ? this.props.seller.tosSigned == true ? true : false : true)
                                            // && <PrivateRoute exact path="/" component={AcceptedBidsContainer} /> 
                                            && <PrivateRoute exact path="/" component={CustomerRequestsContainer} />
                                        }

                                        {
                                            this.props.seller.profileCompleted
                                            && (this.props.isTOSEnabled == true ? this.props.seller.tosSigned == true ? true : false : true)
                                            // && <PrivateRoute exact path={`${NavigationUrls.ACCEPTED_BIDS_URL}`} component={AcceptedBidsContainer} />
                                            && <PrivateRoute exact path={`${NavigationUrls.ACCEPTED_BIDS_URL}`} component={CustomerRequestsContainer} />
                                        }

                                        {/*this.state.showRequests == true && this.props.seller.profileCompleted && this.props.seller.tosSigned && <PrivateRoute exact path={`${NavigationUrls.OPEN_REQUESTS}`} component={OpenRequestsContainer} />
                                    */}

                                        {this.props.seller.profileCompleted
                                            && (this.props.isTOSEnabled == true ? this.props.seller.tosSigned == true ? true : false : true)
                                            &&
                                            <>
                                                <PrivateRoute exact path={`${NavigationUrls.PROFILE_URL}`} component={ProfileContainer} />
                                                <PrivateRoute exact path={`${NavigationUrls.REQUEST_DETAILS_URL}`} component={RequestDetail} />
                                                <PrivateRoute exact path={`${NavigationUrls.ACCEPTED_BID_DETAILS_URL}`} component={RequestDetail} />
                                                <PrivateRoute exact path={`${NavigationUrls.PLACE_BID_URL}`} component={PlaceBidContainerNew} />
                                                <PrivateRoute exact path={NavigationUrls.ACTIVE_SUBSCRIPTION} component={ActiveSubscriptionContainer} />
                                                <PrivateRoute exact path={NavigationUrls.IN_ACTIVE_SUBSCRIPTION} component={InActiveSubscriptionContainer} />
                                                <PrivateRoute exact path={NavigationUrls.ADD_SUBSCRIPTION_WITH_PLAN} component={SubscriptionContainer} />
                                                <PrivateRoute exact path={NavigationUrls.ADD_SUBSCRIPTION} component={SubscriptionContainer} />
                                                <PrivateRoute exact path={NavigationUrls.PENDING_COMMISSION_PAYMENTS} component={CommissionPaymentsContainer} />
                                                <PrivateRoute exact path={NavigationUrls.INVOICES} component={InvoiceContainer} />
                                                <PrivateRoute exact path={NavigationUrls.SERVICES} component={SellerServicesContainer} />
                                                <PrivateRoute exact path={NavigationUrls.SERVICE_AREA} component={ServiceArea} />
                                                <PrivateRoute exact path={NavigationUrls.PREFERENCES} component={Preferences} />
                                                <PrivateRoute exact path={`${NavigationUrls.REQUEST_DETAILS_URL_RESTRICTED}`} component={RestrictedSBRDetails} />
                                                <PrivateRoute exact path={NavigationUrls.TERMS_OF_SERVICE} component={TermsOfService} />
                                                <PrivateRoute exact path={NavigationUrls.PAYMENT_METHOD} component={SellerPaymentMethod} />
                                                <PrivateRoute exact path={NavigationUrls.WORKING_SCHEDULES} component={WorkingSchedules} />
                                                <PrivateRoute exact path={NavigationUrls.SELLER_DRIVER} component={SellerDriverContainer} />
                                                <PrivateRoute exact path={NavigationUrls.INVITE_SELLER_DRIVER} component={InviteSellerDriverContainer} />
                                                {/* SAAS routes */}
                                                {
                                                    <>
                                                        {
                                                            this.props
                                                            && this.props.currentUser
                                                            && this.props.currentUser.Seller &&
                                                            this.props.currentUser?.Seller?.isSaasEnabled &&
                                                            <PrivateRoute exact path={NavigationUrls.CREATE_CUSTOMER_REQUEST} component={CreateCustomerRequestContainer} />
                                                        }

                                                        <PrivateRoute exact path={NavigationUrls.CUSTOMER_REQUEST_FORM} component={CustomerRequestFormContainer} />
                                                        <PrivateRoute exact path={NavigationUrls.CUSTOMER_REQUESTS_LIST} component={CustomerRequestsContainer} />
                                                        <PrivateRoute exact path={NavigationUrls.CUSTOMER_REQUEST_INVOICE} component={CustomerRequestsInvoiceDetailContainer} />
                                                        <PrivateRoute exact path={NavigationUrls.INVOICE_SETTINGS} component={InvoiceSettingsContainer} />
                                                    </>
                                                }

                                                {/* SAAS routes */}


                                            </>
                                        }
                                        {
                                            // console.log("here")
                                        }
                                        <Redirect to="/" />
                                        {/*<PrivateRoute path='/accepted-deals' component={DealsContainer} />
                                    <PrivateRoute path='/expiring-deals' component={DealsContainer} />*/}

                                    </Switch>) :
                                    (<Switch>

                                        {/* Eather seller is not logged in AND does not have any active Subscription */}
                                        <PrivateRoute exact path="/change-password" component={PasswordChangeContainerNew} />
                                        <PrivateRoute exact path={`${NavigationUrls.PROFILE_URL}`} component={ProfileContainer} />
                                        <PrivateRoute exact path={NavigationUrls.ADD_SUBSCRIPTION_WITH_PLAN} component={SubscriptionContainer} />
                                        <PrivateRoute exact path={NavigationUrls.ADD_SUBSCRIPTION} component={SubscriptionContainer} />
                                        {inActiveSubscriptionsCount ? <PrivateRoute exact path={NavigationUrls.IN_ACTIVE_SUBSCRIPTION} component={InActiveSubscriptionContainer} /> : ''}
                                        <PrivateRoute exact path={NavigationUrls.PENDING_COMMISSION_PAYMENTS} component={CommissionPaymentsContainer} />
                                        <PrivateRoute exact path={`${NavigationUrls.COMPLETE_PROFILE_URL}`} component={CompleteProfileContainerNew} />
                                        <PrivateRoute exact path={NavigationUrls.INVOICES} component={InvoiceContainer} />
                                        <PrivateRoute exact path={NavigationUrls.SERVICES} component={SellerServicesContainer} />
                                        <PrivateRoute exact path={NavigationUrls.TERMS_OF_SERVICE} component={TermsOfService} />

                                        {/* SAAS routes */}
                                        {/* <PrivateRoute exact path={NavigationUrls.CREATE_CUSTOMER_REQUEST} component={CreateCustomerRequestContainer} />  */}
                                        {/* <PrivateRoute exact path={NavigationUrls.CUSTOMER_REQUEST_FORM} component={CustomerRequestFormContainer} />  */}
                                        {/* SAAS routes */}
                                        {
                                            this.state.activeSubscriptionsCountDataLoaded
                                                && this.state.inActiveSubscriptionsCountDataLoaded ?
                                                <Route path="*" component={inActiveSubscriptionsCount ? InActiveSubscriptionContainer : NoSubscriptionContainer} /> : ""
                                        }

                                        <PrivateRoute exact path={NavigationUrls.WORKING_SCHEDULES} component={WorkingSchedules} />
                                    </Switch>)
                            }
                        </div> : this.state.sellerDriverID ?
                            <div className="master-content-pane">
                                {/* Seller Driver routes - for driver-only users */}
                                <Switch>
                                    <PrivateRoute exact path="/" component={DispatchedRequestsContainer} />
                                    <PrivateRoute exact path="/change-password" component={PasswordChangeContainerNew} />
                                    <PrivateRoute exact path={NavigationUrls.DRIVER_INVITE_ACCEPTANCE} component={DriverInviteAcceptanceContainer} />
                                </Switch>
                            </div>
                            :
                            <div className='master-loader'>
                                <Dimmer active>
                                    <Loader indeterminate size='massive' />
                                </Dimmer>
                            </div>
                        }
                        {loggedIn ? "" :
                            <div className="main-page-panel find-us">
                                <div className="content-panel">
                                    <div className="heading">
                                        Find Us In
                                    </div>
                                    <div className="slides">
                                        <FindUsContainer></FindUsContainer>
                                        <div className="clearfix">

                                        </div>
                                    </div>

                                </div>
                            </div>
                        }

                        <div className="main-page-panel footer">
                            <FooterContainer topclick={this.onBackToTopClick}></FooterContainer>
                        </div>
                    </div>
                </Container >
                <NotificationContainer />
            </>
        )
    }
}
function mapStateToProps({ auth, reducer, appView, seller }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        loggedIn: auth.loggedIn,
        currentUser: auth.currentUser,
        loginError: auth.loginError,
        homeScreenLoading: reducer.homeScreenLoading,
        showSidebar: appView.showSidebar,
        seller: seller,
        isTOSEnabled: reducer.isTOSEnabled,
        isSeller: auth.isSeller,
        isSellerDriver: auth.isSellerDriver
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthState,
        setShowSidebar,
        setSellerProfileCompleted,
        setActiveSubscriptionCount,
        setInActiveSubscriptionCount,
        setTOSSigned,
        setTOSEnabled
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterContainer);